import * as React from 'react';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import Box from '../primitives/Box';
import { Span, Label } from '../../typography';

type RadioGroupProps = StyledSystemProps & {
  id: string;
  color?: string;
  label: string;
  value: any;
  error: any;
  children: React.ReactNode;
};

const InputFeedback = ({ error }: { error: string }) => (error ? <Span>{error}</Span> : null);

const RadioGroup: React.FunctionComponent<RadioGroupProps> = (props: any) => {
  const { label, children, touched, error } = props;
  return (
    <Box {...props}>
      <Label>{label}</Label>
      <Box flexWrap="wrap" flexDirection="row">
        {children}
      </Box>
      {touched && <InputFeedback error={error} />}
    </Box>
  );
};

export default RadioGroup;

RadioGroup.defaultProps = {
  mb: 3,
  width: '100%',
  flex: 1,
  minWidth: '150px',
  flexWrap: 'wrap',
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledRadioGroup.tsx